import { styled } from "styled-components";

import RedirectComponent, { RedirectText } from "../../RedirectComponent";
import { Check } from "../../../images/CheckMark";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
`;

export interface ConfirmingProps {
  redirectToUri: string;
  redirectAfter?: number | undefined;
  clientName?: string | undefined;
  t: {
    redirect: RedirectText;
  };
}

export default function Confirming({
  redirectAfter,
  redirectToUri,
  clientName,
  t,
}: ConfirmingProps): JSX.Element {
  return (
    <Container data-testid="consent_confirming">
      <RedirectComponent
        seconds={redirectAfter}
        redirectToUri={redirectToUri}
        t={t.redirect}
        clientName={clientName}
      />
      <Check data-testid="consent_checkmark" variant="identification" />
    </Container>
  );
}
